import { groupFilteredPlots } from '../../Services';

export const tooltipDataPoints = (layers, hotspots, plots, isLayerHotspot) => {
  if (isLayerHotspot) {
    return Object.values(layers).reduce((result, layerItem) => {
      const filteredHotspots = hotspots.filter((hotspotItem) => {
        return (
          hotspotItem.layer_id === layerItem.id &&
          hotspotItem.entity_type === 'App\\Models\\Plot'
        );
      });

      if (filteredHotspots.length > 0) {
        const plotsForLayer = filteredHotspots
          .map((hotspotItem) => plots[hotspotItem.entity_id])
          .filter(Boolean);
        result[layerItem.id] = groupFilteredPlots(plotsForLayer, 'status');
      }

      return result;
    }, {});
  }

  return null;
};

export const getStatusAmounts = ({ tooltipDataPoints, clickedHotspotId }) => {
  if (!clickedHotspotId) return {};

  const dataPoints = tooltipDataPoints[clickedHotspotId];

  return {
    'in-voorbereiding': {
      name: 'In voorbereiding',
      objectKey: 'in-voorbereiding',
      amount: dataPoints?.['in-voorbereiding']?.length ?? 0,
    },
    beschikbaar: {
      name: 'Beschikbaar',
      objectKey: 'beschikbaar',
      amount: dataPoints?.['te-koop']?.length ?? 0,
    },
    'in-optie': {
      name: 'In optie',
      objectKey: 'in-optie',
      amount: dataPoints?.['in-optie']?.length ?? 0,
    },
    verkocht: {
      name: 'Verkocht',
      objectKey: 'verkocht',
      amount: dataPoints?.['verkocht']?.length ?? 0,
    },
  };
};
